import { NSARouterMakerResult } from 'namirasoft-account-react';
import { Scheduler, SchedulerRow, SchedulerStateType } from 'namirasoft-scheduler';
import { DateTimeFormatter, NSBox, NSButtonBlue, NSColumn, NSLabel, NSPanel } from 'namirasoft-site-react';
import { Component } from 'react';

export interface UpcomintRunsProps extends NSARouterMakerResult
{
    getRow: () => SchedulerRow;
}

export interface UpcomintRunsState
{
    runs: SchedulerStateType[][];
}

export class UpcomintRuns extends Component<UpcomintRunsProps, UpcomintRunsState>
{
    constructor(props: UpcomintRunsProps)
    {
        super(props);
        this.state = { runs: [] };
        this.getSchedules = this.getSchedules.bind(this);
    }

    getSchedules(onFinished: () => void)
    {
        try
        {
            let row = this.props.getRow();
            let date = new Date();
            row.start_date_time = new Date(row.start_date_time);
            let runs: SchedulerStateType[][] = [];

            for (let i = 0; i < 20; i++)
            {
                let res = Scheduler.getSchedule(row, date);
                runs.push(res.runs);

                if (res.next_run == null)
                    break;

                row.next_schedule = res.next_schedule;
                row.next_run = res.next_run;
                row.state = res.next_state;
                date = new Date(Math.min(res.next_run.getTime(), res.next_schedule.getTime()));
            }

            this.setState(() => ({ runs }), onFinished);
        }
        catch (error)
        {
            this.props.notifier.onError(error as Error);
            onFinished();
        }
    }

    override render()
    {
        return (
            <NSColumn style={{ alignItems: "center" }}>
                <NSButtonBlue
                    title="Show Next 20 Runs"
                    onClick={{
                        showLoading: true,
                        action: this.getSchedules
                    }}
                />
                {
                    this.state.runs.map((run, i) => (
                        <NSPanel
                            key={i + 1}
                            style={{ width: "100%", maxWidth: NSBox.width.double, padding: "0.5rem", flexDirection: "row" }}
                        >
                            <NSLabel title={`Next Run ${i + 1}`}>
                                <NSColumn style={{ marginTop: "0.5rem", gap: "0.5rem" }}>
                                    {
                                        run.map((item, j) => (
                                            <span key={j + 1} style={{ color: "#000" }}>
                                                {`${j + 1}) ${new DateTimeFormatter().format(item.every_next_run.date_with_delay)}`}
                                            </span>
                                        ))
                                    }
                                </NSColumn>
                            </NSLabel>
                        </NSPanel >
                    ))
                }
            </NSColumn>
        );
    }
}

export default UpcomintRuns;